import { watch, ref } from 'vue'
import { isString } from '@/utils/is'
import { useAppStoreWithOut } from '@/store/modules/app'
import { useI18n } from '@/hooks/web/useI18n'

/** 当前页标题（路由 meta.title），全局单例避免 afterEach 重复注册 watch */
const pageTitleRef = ref<string>()
let titleWatchStarted = false

function ensureTitleWatch() {
  if (titleWatchStarted) return
  titleWatchStarted = true

  const { t } = useI18n()
  const appStore = useAppStoreWithOut()

  watch(
    [() => appStore.getTitle, pageTitleRef],
    () => {
      if (!document) return
      const appName = appStore.getTitle
      const page = pageTitleRef.value
      const next = page ? `${appName} - ${t(page)}` : appName
      if (isString(next) && document.title !== next) {
        document.title = next
      }
    },
    { immediate: true }
  )
}

/**
 * 浏览器标签页标题：系统配置「系统名称」+ 当前页名称
 * @param newTitle 路由 meta.title；未传则仅刷新为系统名称
 */
export const useTitle = (newTitle?: string) => {
  ensureTitleWatch()
  if (newTitle !== undefined) {
    pageTitleRef.value = newTitle
  }
  return pageTitleRef
}
